<script>
	import { storefront_api_prefix } from 'shared/var'
	import fetchy from 'shared/fetchy'
	import ErrorMessage from 'component/ErrorMessage.svelte'
	import { onMount } from 'svelte'

	const api_deprecated_fetch = fetchy(storefront_api_prefix + `/p/`)

	export let cof_img_alt
	export let cof_img_url
	export let content_html
	export let range_video_key

	const range_video_helper_text = `Since some are visual learners, we have summarized our drill videos into short segments that can be easily downloaded and taken with you. Only the essentials were left to provide a quick, easy tool that can be referenced when you're out at the range. These videos feature a brief summary of each drill and an example of how we run them.`

	let video_promise = null
	let video_element

	function download_range_use_video(mux_playback_id, title) {
		const range_use_video_href = `https://stream.mux.com/${ mux_playback_id }/high.mp4?download=${ title }`
		window.location.href = range_use_video_href
	}

	function download_cof_pdf() {
		const cof_pdf_href = `${ cof_img_url }.pdf`
		window.location.href = cof_pdf_href
	}

	function download_cof_spreadsheet() {
		const cof_spreadsheet_href = `https://static.trex-arms.com/drills/trex-arms_courses_of_fire_-_rev_1.xlsx`
		window.location.href = cof_spreadsheet_href
	}

	onMount(async() => {
		video_promise = api_deprecated_fetch(`video/${ range_video_key }`, { method: `GET` })

		const video = await video_promise

		window.player_barnacle.default(video_element, { id: range_video_key, ...video })
	})
</script>

<div class="full-width">
  <div class="button-container mobile">
    <button on:click={download_cof_pdf}>Download COF PDF</button>
    <button on:click={download_cof_spreadsheet}>Download COF Spreadsheet</button>
  </div>

  {@html content_html}
</div>

<h2>For Range Use</h2>

<p class="mobile">{range_video_helper_text}</p>

<div class="resource-container full-width">
	<!-- svelte-ignore a11y-media-has-caption -->
	<video
		bind:this={video_element}
		preload
		class="trex_player media"
	></video>

	{#await video_promise then video}
		<div class="button-container desktop">
			<button on:click="{() => download_range_use_video(video.mux_playback_id, video.title)}">Download Range Use Video</button>
			<p>{range_video_helper_text}</p>
		</div>
	{:catch error}
		<ErrorMessage server_error_response={error} />
	{/await}
</div>

<div class="resource-container full-width">
	<div class="media">
		<a class="print" href="{cof_img_url}.pdf">
			<button>Download</button>
			<img src="{cof_img_url}.jpg" alt={cof_img_alt}>
		</a>
	</div>

	<div class="button-container desktop">
		<button on:click={download_cof_pdf}>Download COF PDF</button>
		<button on:click={download_cof_spreadsheet}>Download COF Spreadsheet</button>
	</div>
</div>

<style>
.resource-container {
	display: flex;
	gap: 2rem;
	padding: 0 20px;
}

.trex_player {
	margin-bottom: 2rem;
}

p.mobile {
	display: none;
}

.button-container {
	display: flex;
	gap: 1rem;
}

.button-container.mobile {
	display: none;
	margin: 20px 20px 0 20px;
	justify-content: center;
}

.button-container.desktop {
	flex-direction: column;
	flex-wrap: wrap;
	align-content: flex-start;
	flex-basis: 300px;
	flex-shrink: 0;
}

:global(.with_chapters) {
	padding: 20px;
	overflow:hidden;
}

.print {
	border: 1px solid #ceff51;
	display: block;
	border-radius: 10px;
	overflow: hidden;
	position: relative;
}

.print button {
	position: absolute;
	top: 1rem;
	right: 1rem;
	z-index: 10;
}

.print img {
	filter: invert(1);
	display: block;
}

@media (max-width:900px) {
	p.mobile {
		display: block;
		margin-top: 0;
	}

	.button-container.mobile {
		display: flex;
	}

	.button-container.desktop {
		display: none;
	}
}
</style>
